import { toast } from 'react-toastify';
import { clearTokens } from '../Api/authToken';
import { stopPresence } from '../Services/presenceService';

export const DEACTIVATED_MSG = 'Your account has been deactivated. Please contact the administrator.';
export const DELETED_MSG = 'Your account has been deleted. Please create a new account.';

export const isAccountDeactivatedError = (err) => {
  const code = err?.response?.data?.code;
  const msg = err?.response?.data?.error || '';
  return code === 'ACCOUNT_DEACTIVATED' || msg.includes('deactivated');
};

export const isAccountDeletedError = (err) => {
  const code = err?.response?.data?.code;
  const msg = err?.response?.data?.error || '';
  return code === 'ACCOUNT_DELETED' || String(msg).toLowerCase().includes('account has been deleted');
};

export const forceUserLogout = (message = DEACTIVATED_MSG) => {
  stopPresence?.();
  clearTokens('user');
  localStorage.removeItem('loggedUser');
  localStorage.removeItem('active_status_token');
  if (message) toast.error(message);
  if (!window.location.pathname.startsWith('/login')) {
    window.location.href = '/login';
  }
};
